import * as IconSelector from '../icons';

// Constantes exportadas
export const LOG_STATE = 'LOG_STATE';
export const LOG_DATA = 'LOG_DATA';

// Definición del enum
export const changeLogs = [
    {
        value: LOG_STATE,
        label: 'Estado',
        description: 'Estado',
        icon: IconSelector.ChangeLogStateIcon,
        color: 'Orange'
    },
    {
        value: LOG_DATA,
        label: 'Cambios',
        description: 'Cambios',
        icon: IconSelector.ChangeLogDataIcon,
        color: 'Green'
    }
];
